import { Autocomplete, Divider, Grid, ListItemIcon, ListItemText, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss' 
import autoCompleteStyles from './../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss' 
import waCampaignStyle from "../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import globalStyles from './../../../../assets/styles/global.module.scss'
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext'
import { UserContext, UserContextPayload } from '../../../../context/userContext'
import agent from '../../../../services/api'
import { checkIfBtnDynamicVarExist, flagShowCarouselGlobalHeaderVariable, getFileTypeImgIcon } from '../../../../utils/constants'
import { chatbotIntegratedChannelDeploymentObj, customVariableDataInterface, EcomProduct, getTemplateDetails, interactiveType, metaIntegrationWhatsAppDataNew, whatsappTemplateButton } from '../../../../models/axiosModel'
import Required from '../../../utility/required'
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../../context/whatsappCampaignContext'
import DynamicBodyVariables from './dynamicBodyVariables'
import DynamicHeaderVariables from './dynamicHeaderVariables'
import DynamicButtonVariables from './dynamicButtonVariables'
import WorkflowTemplatePreview from './workflowTemplatePreview'
import previewIcon from '../../../../assets/chatbotAssets/Chatbot-Preview-Arrow.svg'
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { isCarouselTemplateActionType, isCurrentViewVersionPublished, isSendOrderDetailTemplateActionType } from '../../../dashboard/flowBuilder/utilityFunctions'
import { isInteractiveTypeMessageOrderDetails, renderTemplateOptions } from '../../../dashboard/channels/global/whatsapp/templates/utils'
import { primaryColor, secondaryColor } from '../../../../utils/colors'
import { isCarouselTemplate } from '../../../dashboard/whatsappCampaign/campaignConstant'
import CarouselGlobalHeaderVariables from './carouselGlobalHeaderVariables'
import CarouselCardVariables from './carouselCardVariables'
import WorkflowCarouselTemplatePreview from './workflowCarouselTemplatePreview'
import IconsColor from '../../../utility/iconsColor'
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore'
import validator from 'validator';
import { debounce } from 'lodash';
import FlowVariables from './flowVariables';
import { WhatsappFlow, WhatsappFlowVersion } from '../../../dashboard/channels/global/whatsapp/flows/waFlowTypes';
import SendOrderDetailsProductVariables from './sendOrderDetailsProductVariables';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { isWhatsAppIntegration } from '../../../../pages/ruleBasedInbox/utils';
import { WhatsappTemplateContext, WhatsappTemplateContextPayload } from '../../../../context/whatsappTemplateContext';

type mergedConfiguredAndNotConfiguredFlowInputVariableInterface = {
  flag_configured: boolean;
  whatsapp_flow_variable_id: string | number;
  variable_details: any;
}; 

type mergedConfiguredAndNotConfiguredProductVariableInterface = {
    flag_configured: boolean;
    ecom_product_id: string | number;
    variable_details: any;
}

const WhatsappTemplateIntegration = (props: any) => {
    const { actionData, stepAction, selectedWBA, setSelectedWBA, selectedPhoneNumber, setSelectedPhoneNumber, setWaTemplateFetchedOnChange, waTemplateFetchedOnChange } = props;

    const { integrationListNewStructure, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, flagLoading, userDetail, handleError } = useContext(UserContext) as UserContextPayload
    const { getWhatsappTemplateDetailsApiCall } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const { sortTemplateList } = useContext(WhatsappTemplateContext) as WhatsappTemplateContextPayload;
    const { onChangeCurrentActiveNodeConfig, nodes, currentActiveNodeConfig, setInvalidHeaderId, setInvalidButtonId, inValidVariableId, setInValidVariableId, variableTypes } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const [messageTemplateDetail, setMessageTemplateDetail] = useState<any>(null)
    const [messageTemplateList, setMessageTemplateList] = useState<getTemplateDetails[]>([]);
    const [showTemplatePreview, setShowTemplatePreview] = useState<boolean>(false);

    const [interactiveTypeList, setInteractiveTypeList] = useState<interactiveType[] | null>(null);
    const [eComProductDataList, setEComProductDataList] = useState<EcomProduct[] | null>(null);

    const mobileScreen = useMediaQuery('(max-width : 900px) and (min-width : 0px)')

    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const metaDataVariableList = useFlowBuilderStore((state) => state.metaDataVariableList)

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    // const [inputFlowVariables, setInputFlowVariables] = useState<flowVariables[] | null>(null);  
    const [whatsappFlowData, setWhatsappFlowData] = useState<WhatsappFlow[] | null>(null);

    const inValidIdRef = useRef<number[]>([]);
    const [files, setFiles] = useState<any>([]);
    const [progress, setProgress] = useState({ filename: "", percent: 0 });
    const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);

    const getWhatsAppNumberOptions = () => {
        if (!integrationListNewStructure) return [];

        return integrationListNewStructure.filter(isWhatsAppIntegration)
            .find((waba: metaIntegrationWhatsAppDataNew) => waba.waba_id == selectedWBA?.waba_id)
            ?.meta_integration_phone_number_data || [];
    }

    const getWhatsAppNumberValue = () => {
        const options = getWhatsAppNumberOptions();
        return options.find((phoneNumberData: any) => phoneNumberData.meta_integration_whatsapp_phone_number_id === selectedPhoneNumber?.meta_integration_whatsapp_phone_number_id) || null;
    }

    const onChangeOfWBA = (value: any) => {
        if (selectedPhoneNumber) {
            setSelectedPhoneNumber(null);
        }
        setSelectedWBA(value);
        if (value) {
            getMessageTemplateListApiCall(value?.meta_integration_whatsapp_id)
        }
    }

    const onChangeOfPhoneNumber = (value: any) => {
        setSelectedPhoneNumber(value);
    }

    const getMessageTemplateListApiCall = async (meta_integration_whatsapp_id: number) => {
        const res = await agent.getWhatsappTemplateList.get(meta_integration_whatsapp_id);
        if (res.status) {
            setMessageTemplateList(sortTemplateList(res?.data ?? []));
        } else {
            handleError(res);
        }
    } 

    const isMediaHeaderType = (headerTypeName?: string) => {
        const type = headerTypeName?.toLowerCase();
        return type === "image" || type === "video" || type === "document";
    }

    const getStaticVariableType = () => {
        return variableTypes.find((type) => type.variable_type_name?.toLowerCase() === "static") || {
            variable_type_id: "3c599689-9c86-4bb9-bfd8-89b5ebc81668",
            variable_type_name: "Static",
            variable_label: "Static"
        };
    }

    const getTemplateVariablesId = (templateDetails: any) => {
        const staticVariableType = getStaticVariableType();

        if(isCarouselTemplate(templateDetails)){
            return (
                [
                    // Global Header Variables 
                    ...(templateDetails?.whtatsapp_carousel_header_variable_data?.map((variable: any) => {
                            return {
                                whatsapp_template_dynamic_variable_id: variable.whatsapp_template_dynamic_variable_id, 
                                whatsapp_template_carousel_variation_id: null,
                            }
                        }) 
                    || []), 

                    // Card Variables 
                    ...(templateDetails?.whatsapp_template_data?.map((template: any) => {
                        const isMediaHeader = isMediaHeaderType(template?.whatsapp_template_header?.whatsapp_template_header_type_name);
                        return (
                            [
                                // Card Header Variable
                                ...(template?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.map(
                                    (hVariable: any) => {
                                        return ({
                                            whatsapp_template_dynamic_variable_id: hVariable.whatsapp_template_dynamic_variable_id, 
                                            whatsapp_template_carousel_variation_id: template?.whatsapp_template_carousel_variation_id,
                                            ...(isMediaHeader ? { variable_type: staticVariableType } : {}),
                                        })
                                    }
                                ) || []), 

                                // Card Body Variables
                                ...(template?.whatsapp_template_body?.whatsapp_template_body_variable_data?.map(
                                    (bVariable: any) => { 
                                        return ({
                                            whatsapp_template_dynamic_variable_id: bVariable.whatsapp_template_dynamic_variable_id, 
                                            whatsapp_template_carousel_variation_id: template?.whatsapp_template_carousel_variation_id,
                                        });
                                    }
                                ) || []),

                                // Card Button Variables
                                ...(template?.whatsapp_template_button?.flatMap(
                                        (btn: any) =>
                                            btn.whatsapp_template_button_data?.flatMap(
                                                (data: any) =>
                                                    data.whatsapp_template_button_sub_type_field_data?.flatMap(
                                                        (field: any) =>
                                                            field.whatsapp_template_button_field_data_variable?.map(
                                                                (subVars: any) => {
                                                                    return ({
                                                                        whatsapp_template_dynamic_variable_id: subVars.whatsapp_template_dynamic_variable_id, 
                                                                        whatsapp_template_carousel_variation_id: template?.whatsapp_template_carousel_variation_id,
                                                                    });
                                                                }
                                                            )
                                                    )
                                            ) || []
                                    ) || []),
                            ]?.filter(Boolean)
                        );
                    }) || [])
                ]?.flat()?.filter(Boolean)
            ); 
        } else {
            const isMediaHeader = isMediaHeaderType(
                templateDetails?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name
            );

            return (
                [
                    // Header variables
                    ...(templateDetails?.whatsapp_template_data[0]?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.map(
                        (varHeader: any) => ({
                            whatsapp_template_dynamic_variable_id: varHeader.whatsapp_template_dynamic_variable_id,
                            ...(isMediaHeader ? { variable_type: staticVariableType } : {}),
                        })
                    ) || []),

                    // Body variables
                    ...(templateDetails?.whatsapp_template_data[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data?.map(
                        (varBody: any) => ({
                            whatsapp_template_dynamic_variable_id: varBody.whatsapp_template_dynamic_variable_id,
                        })
                    ) || []),

                    // Button variables
                    ...(templateDetails?.whatsapp_template_data[0]?.whatsapp_template_button?.flatMap(
                        (btn: any) =>
                            btn.whatsapp_template_button_data?.flatMap(
                                (data: any) =>
                                    data.whatsapp_template_button_sub_type_field_data?.flatMap(
                                        (field: any) =>
                                            field.whatsapp_template_button_field_data_variable?.map(
                                                (subVars: any) => ({
                                                    whatsapp_template_dynamic_variable_id: subVars.whatsapp_template_dynamic_variable_id,
                                                })
                                            )
                                    )
                            ) || []
                    ) || [])
                ]?.filter(Boolean)
            );
        }
    } 

    const getFlowVariablesObject = (templateDetails: any) => {
        let whatsapp_flow_data: WhatsappFlow[] | null = null;

        templateDetails?.whatsapp_template_data?.[0]?.whatsapp_template_button?.map((btn: any) => {
            const buttonData = btn?.whatsapp_template_button_data?.find((btnData: any) => {
                return btnData?.whatsapp_template_button_type_name?.toLowerCase() == "flow" && btnData?.whatsapp_template_button_sub_type_name?.toLowerCase() == "open form";
            });
            if(buttonData){ 
                if(!whatsapp_flow_data) whatsapp_flow_data = [buttonData?.whatsapp_flow_data]
                else whatsapp_flow_data.push(buttonData?.whatsapp_flow_data);
            }
            return buttonData;
        }); 

        if(!whatsapp_flow_data) return [];
        else return (whatsapp_flow_data as WhatsappFlow[])?.map((flow: WhatsappFlow) => {
            return {
                flow_id: flow?.whatsapp_flow_id,  
                flow_variables: flow?.whatsapp_flow_version_data?.find((version: WhatsappFlowVersion) => {
                    return version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() == "published";
                })?.whatsapp_flow_variables?.filter((variable) => variable?.input_variable_flag)?.map((variable) => {
                    return {
                        flag_configured: false,
                        whatsapp_flow_variable_id: variable?.whatsapp_flow_variable_id, 
                    }
                }) || [],
            }
        }) || [];
    }  

    const getSendOrderDetailProductVariablesObject = () => {
        if(eComProductDataList){
            return eComProductDataList.map((product) => {
                return product?.ecom_product_id;
            })
        } 
        return [];
    }

    const mergeConfiguredAndNotConfiguredFlowInputVariables = (configuredVariables: any[], notConfiguredVariables: any[]) => {
        const convertKeyToString = (id: string | number | undefined | null) => String(id ?? "");
        const getIdInString = (v: any) => String(v?.whatsapp_flow_variable_id);

        const flowMap = new Map<string, mergedConfiguredAndNotConfiguredFlowInputVariableInterface[]>();

        for (const configured_variable of configuredVariables) {
            const flow_id = convertKeyToString(configured_variable.action_send_dm_wa_template_flow_id);
            const variables = (configured_variable.action_send_dm_wa_any_template_flow_input_variable ?? []).map((variable: any) => ({
                flag_configured: true,
                whatsapp_flow_variable_id: variable.whatsapp_flow_variable_id,
                variable_details: variable,
            })) as mergedConfiguredAndNotConfiguredFlowInputVariableInterface[];

            flowMap.set(flow_id, variables);
        }

        for (const notConfigured_variable of notConfiguredVariables) {
            const flow_id = convertKeyToString(notConfigured_variable.action_send_dm_wa_template_flow_id ?? notConfigured_variable.flow_id);
            const variables =
                notConfigured_variable.action_send_dm_wa_any_template_flow_input_variable ??
                notConfigured_variable.flow_variables ??
                [];

            const notConfiguredVariables = (variables as any[]).map(variable => ({
                flag_configured: false,
                whatsapp_flow_variable_id: variable.whatsapp_flow_variable_id,
                variable_details: variable,
            })) as mergedConfiguredAndNotConfiguredFlowInputVariableInterface[];

            if (!flowMap.has(flow_id)) {
                flowMap.set(flow_id, notConfiguredVariables);
            } else {
                const existingFlowIdArray = flowMap.get(flow_id)!;
                const existingFlowIds = new Set(existingFlowIdArray.map(existingId => getIdInString(existingId)));
                const toAppend = notConfiguredVariables.filter(variable => !existingFlowIds.has(getIdInString(variable)));
                flowMap.set(flow_id, existingFlowIdArray.concat(toAppend));
            }
        }

        return Array.from(flowMap.entries()).map(([flow_id, flow_variables]) => ({
            flow_id,
            flow_variables,
        }));
    }

    const mergeConfiguredAndNotConfiguredEComProductVariables = (configuredVariables: any[], notConfiguredVariables: any[]) =>{
        let allProductVariables = [];
        for (let i = 0; i < configuredVariables?.length; ++i){
            allProductVariables.push({
                flag_configured: true,
                variable_details: configuredVariables[i],
            })
        }
        for (let i = 0; i < notConfiguredVariables?.length; ++i){
             allProductVariables.push({
                flag_configured: false,
                variable_details: notConfiguredVariables[i],
            })
        }

        return allProductVariables;
    }

    const getInteractiveTypeCall = async () => {
        const res = await agent.getInteractiveType.get();
        if(!(res.status)){
            handleError(res);
        } else {
            setInteractiveTypeList(res.data);
        }
    }

    const getEComProductCall = async () => {
        const res = await agent.getEComProduct.get(String(userDetail?.user_organization_data?.organization_id) ?? ""); 
        if(!(res.status)){
            handleError(res);
        } else {
            setEComProductDataList(res.data);
        }
        return res?.data || [];
    }

    useEffect(() => {
        const fetchData = async () => {
            if (currentActiveStaticWorkflow && stepAction && !waTemplateFetchedOnChange) {
                const whatsAppChannel = currentActiveStaticWorkflow.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined;
                if (whatsAppChannel?.meta_integration_whatsapp_id) {
                    let EComProductList = null; 

                    if(isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name)){
                        (async () => {
                            setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
                            EComProductList = await getEComProductCall();
                            setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
                        })();
                    } 
                    if(isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) || stepAction?.action_type?.action_type_name?.toLowerCase() == "send_wa_dm_template"){
                        await getInteractiveTypeCall();
                    }
    
                    await getMessageTemplateListApiCall(
                        whatsAppChannel.meta_integration_whatsapp_id
                    );
    
    
                    if (currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.length && actionData.whatsapp_template.whatsapp_template_id) {
                        await getWhatsappTemplateDetailsApiCallAsync(whatsAppChannel.meta_integration_whatsapp_id, actionData.whatsapp_template.whatsapp_template_id, false, EComProductList)
                        setWaTemplateFetchedOnChange(true)
                    } else {
                        setMessageTemplateDetail(null)
                    }
                }
            }
        }
        fetchData();
    }, [stepAction]);
    //changed from currentActiveStaticWorkflow to stepAction

    const getWhatsappTemplateDetailsApiCallAsync = async (meta_integration_whatsapp_id: number, whatsapp_template_id: number, flagOnChange: boolean, EComProductList?: EcomProduct[] | null) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        let templateDetails: any = []
        // if (currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.length) {
        //     templateDetails = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => Number(template.whatsapp_template_id) == Number(whatsapp_template_id))
        // } 
        // else {

        const res = await getWhatsappTemplateDetailsApiCall(meta_integration_whatsapp_id, whatsapp_template_id);
        if (!(res.status)) {
            handleError(res);
            templateDetails = (null)
        } else {
            templateDetails = res.data[0]
        }
        // }
        setMessageTemplateDetail(templateDetails)
        let whatsapp_flow_data: WhatsappFlow[] | null = null;

        if(flagShowFlowVariables(templateDetails)){

            templateDetails?.whatsapp_template_data?.[0]?.whatsapp_template_button?.map((btn: any) => {
                const buttonData = btn?.whatsapp_template_button_data?.find((btnData: any) => {
                    return btnData?.whatsapp_template_button_type_name?.toLowerCase() == "flow" && btnData?.whatsapp_template_button_sub_type_name?.toLowerCase() == "open form";
                });
                if(buttonData){ 
                    if(!whatsapp_flow_data) whatsapp_flow_data = [buttonData?.whatsapp_flow_data]
                    else whatsapp_flow_data.push(buttonData?.whatsapp_flow_data);
                }
                return buttonData;
            });
            setWhatsappFlowData(whatsapp_flow_data);
        } else {
            setWhatsappFlowData(null);
        }

        if (flagOnChange) {     //only change when we change template from dropdown  
            if(isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name)){
                   onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                        {
                            ...actionData, 
                            flag_update_wa_template: true,
                            wa_template: {
                                whatsapp_template_id: templateDetails?.whatsapp_template_id,
                                whatsapp_template_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_name,
                                whatsapp_template_display_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_display_name
                            },
                            wa_send_order_detail_template_variables: getTemplateVariablesId(templateDetails), 
                            wa_send_order_detail_template_product_variables: getSendOrderDetailProductVariablesObject(),
                        },
                        {
                            updateType: "editExistingStepAction"
                        }
                    );   
            } else {
                if(flagShowFlowVariables(templateDetails)){ 
                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                        {
                            ...actionData, 
                            flag_update_wa_template: true,
                            flag_update_wa_flow_variable: true,
                            wa_template: {
                                whatsapp_template_id: templateDetails?.whatsapp_template_id,
                                whatsapp_template_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_name,
                                whatsapp_template_display_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_display_name
                            },
                            wa_flow_variables: getFlowVariablesObject(templateDetails), 
                            wa_variables: getTemplateVariablesId(templateDetails) || [],
                        },
                        {
                            updateType: "editExistingStepAction"
                        }
                    );  
                } else {
                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                        {
                            ...actionData,
                            flag_update_wa_template: true,
                            wa_template: {
                                whatsapp_template_id: templateDetails?.whatsapp_template_id,
                                whatsapp_template_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_name,
                                whatsapp_template_display_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_display_name
                            },
                            wa_variables: getTemplateVariablesId(templateDetails) || [], 
                            flag_update_wa_flow_variable: true,
                            wa_flow_variables: null,
                        },
                        {
                            updateType: "editExistingStepAction"
                        }
                    );  
                }
            }
        } else { 
            if(isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name)){

                const not_configured_product_variables = EComProductList ? 
                    EComProductList?.filter((product) => {
                        return !stepAction?.action_data?.action_send_order_details_template_product_variable_data?.find((productVar: any) => productVar?.ecom_product_id == product?.ecom_product_id)
                    })
                : []

                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                    {
                        ...actionData, 
                        flag_update_send_order_detail_product_variable: true,
                        wa_template: {
                            whatsapp_template_id: templateDetails?.whatsapp_template_id,
                            whatsapp_template_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_name,
                            whatsapp_template_display_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_display_name
                        },
                        send_order_details_product_variables: mergeConfiguredAndNotConfiguredEComProductVariables(stepAction?.action_data?.action_send_order_details_template_product_variable_data, not_configured_product_variables),
                    },
                    {
                        updateType: "editExistingStepAction"
                    }
                ); 
            }
            if(flagShowFlowVariables(templateDetails)){
                const not_configured_input_variables = whatsapp_flow_data ? (whatsapp_flow_data as WhatsappFlow[])?.map((flow: WhatsappFlow) => { 
                    const publishVersion = flow?.whatsapp_flow_version_data?.find((version) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() == "published");

                    return {
                        action_send_dm_wa_template_flow_id: flow?.whatsapp_flow_id, 
                        action_send_dm_wa_any_template_flow_input_variable: publishVersion ? 
                            publishVersion?.whatsapp_flow_variables?.filter((variables) => {
                                return !stepAction?.action_data?.action_send_dm_wa_any_template_flow_variable?.find((flowVar: any) => flowVar?.action_send_dm_wa_template_flow_id == flow?.whatsapp_flow_id)?.action_send_dm_wa_any_template_flow_input_variable?.find((inputVar: any) => inputVar?.whatsapp_flow_variable_id == variables?.whatsapp_flow_variable_id)
                            })
                        : [],
                    }
                }) : [];
                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                    {
                        ...actionData, 
                        flag_update_wa_flow_variable: true,
                        wa_template: {
                            whatsapp_template_id: templateDetails?.whatsapp_template_id,
                            whatsapp_template_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_name,
                            whatsapp_template_display_name: templateDetails?.whatsapp_template_data[0]?.whatsapp_template_display_name
                        },
                        wa_flow_variables: mergeConfiguredAndNotConfiguredFlowInputVariables(stepAction?.action_data?.action_send_dm_wa_any_template_flow_variable, not_configured_input_variables),
                    },
                    {
                        updateType: "editExistingStepAction"
                    }
                );  
            }
        }


        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const getTemplateDetailsFromMessageTemplate = async (meta_integration_whatsapp_id: number | undefined, whatsapp_template_id: number | undefined) => {

        if (meta_integration_whatsapp_id && whatsapp_template_id) {
            await getWhatsappTemplateDetailsApiCallAsync(meta_integration_whatsapp_id, whatsapp_template_id, true);
        } else {
            setMessageTemplateDetail(null);

        }
    }
    const flagShowHeaderVariables = () => {
        return (messageTemplateDetail && messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data.length > 0 &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length > 0)
    }

    const flagShowBodyVariable = () => {
        return (messageTemplateDetail && messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.length > 0);
    }

    const flagShowButtonVariable = () => {
        return (messageTemplateDetail && messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button.length > 0 && checkIfBtnDynamicVarExist(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button)
        )
    }

    const flagShowSendOrderDetailProductVariable = () => {
        if(eComProductDataList && eComProductDataList?.length > 0){
            return true;
        } 
        return false;
    }

    const getIntegrationListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await getMetaIntegrationList(true)
        if (res.status) {
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    useEffect(() => {
        (async () => {
            if (!integrationListNewStructure) {
                await getIntegrationListApiCall();
            }
        })()
    }, [])

    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        return (
            renderTemplateOptions(props, option, option.contact_tag_id, { backgroundColor: messageTemplateDetail?.whatsapp_template_id == option?.whatsapp_template_id ? secondaryColor : "" })
        )
    } 

    const getFieldTypeValue = (whatsapp_template_dynamic_variable_id: number) => {
        let type = (isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) ? stepAction?.action_data?.action_send_order_details_template_variable_data : isCarouselTemplate(messageTemplateDetail) ? stepAction?.action_data?.action_send_dm_wa_carousel_template_variable_data : stepAction?.action_data?.action_send_dm_wa_template_variable_data)?.find((stepActionVar: any) => stepActionVar.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id)?.variable_type
        // return type
        let option = variableTypes.find((option) => option?.variable_type_id == type?.variable_type_id)
        return option
    }  

    const getFieldTypeValueForFlowVariable = (flow_id: number,  whatsapp_flow_variable_id: number) => {
        let type = stepAction?.action_data?.action_send_dm_wa_any_template_flow_variable?.find((variable: any) => variable?.action_send_dm_wa_template_flow_id == flow_id)?.action_send_dm_wa_any_template_flow_input_variable?.find((inputVar: any) => inputVar?.whatsapp_flow_variable_id == whatsapp_flow_variable_id)?.variable_type;
        
        let option = variableTypes.find((option) => option?.variable_type_id == type?.variable_type_id)
        return option
    }

    const getFieldValue = (whatsapp_template_dynamic_variable_id: number) => {
        let variableData = customVariableList?.custom_variable_data
        // @ts-ignore
        let actionVarConfig = (isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) ? actionData?.action_send_order_details_template_variable_data :  isCarouselTemplate(messageTemplateDetail) ? actionData?.action_send_dm_wa_carousel_template_variable_data : actionData?.action_send_dm_wa_template_variable_data)?.find((vari: any) => Number(vari.whatsapp_template_dynamic_variable_id) == Number(whatsapp_template_dynamic_variable_id))
        if (actionVarConfig.variable_type.variable_type_name == "Custom") {
            return variableData?.find((vari) => vari.chatbot_custom_variable_configuration_id == actionVarConfig?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id)
        } else if (actionVarConfig.variable_type.variable_type_name == "Metadata") {
            // @ts-ignore
            return metaDataVariableList?.find((channel) => channel.channel_name.toLowerCase() == currentActiveStaticWorkflow?.chatbot_channel?.channel_name.toLowerCase())?.metadata_type?.find((metadata) => metadata.metadata_type_id == actionVarConfig?.metadata_type?.metadata_type_id)
        }
        else {
            return null
        }
    }  

    const getFieldValueForFlowVariable = (flow_id: number,  whatsapp_flow_variable_id: number) => {
        let variableData = customVariableList?.custom_variable_data
        
        // @ts-ignore
        let actionVarConfig = actionData?.action_send_dm_wa_any_template_flow_variable?.find((variable: any) => variable?.action_send_dm_wa_template_flow_id == flow_id)?.action_send_dm_wa_any_template_flow_input_variable?.find((inputVar: any) => inputVar?.whatsapp_flow_variable_id == whatsapp_flow_variable_id);
        if (actionVarConfig.variable_type.variable_type_name == "Custom"){
            return variableData?.find((vari) => vari.chatbot_custom_variable_configuration_id == actionVarConfig?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id)
        } else if (actionVarConfig.variable_type.variable_type_name == "Metadata") {
            // @ts-ignore
            return metaDataVariableList?.find((channel) => channel.channel_name.toLowerCase() == currentActiveStaticWorkflow?.chatbot_channel?.channel_name.toLowerCase())?.metadata_type?.find((metadata) => metadata.metadata_type_id == actionVarConfig?.metadata_type?.metadata_type_id)
        }
        else {
            return null
        }
    }

    const getFallbackValue = (whatsapp_template_dynamic_variable_id: number) => {
        // @ts-ignore
        let actionVarConfig = (isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) ? actionData?.action_send_order_details_template_variable_data : isCarouselTemplate(messageTemplateDetail) ? actionData.action_send_dm_wa_carousel_template_variable_data : actionData?.action_send_dm_wa_template_variable_data)?.find((vari: any) => Number(vari.whatsapp_template_dynamic_variable_id) == Number(whatsapp_template_dynamic_variable_id))
        if (actionVarConfig?.fallback_value) {
            return actionVarConfig.fallback_value || "";
        } else {
            return "";
        }
    } 

    const getFallbackValueForFlowVariable = (flow_id: number,  whatsapp_flow_variable_id: number) => {
        // @ts-ignore
        let actionVarConfig = actionData?.action_send_dm_wa_any_template_flow_variable?.find((variable: any) => variable?.action_send_dm_wa_template_flow_id == flow_id)?.action_send_dm_wa_any_template_flow_input_variable?.find((inputVar: any) => inputVar?.whatsapp_flow_variable_id == whatsapp_flow_variable_id)
        if (actionVarConfig?.fallback_value) {
            return actionVarConfig.fallback_value || "";
        } else {
            return "";
        }
    } 

    function getFilteredTemplateList(templateList: getTemplateDetails[]) {
        // filtering only approved templates without tracking enabled & interactive messages 
        let filteredTemplateList = templateList.filter((template) => ((template.whatsapp_template_metadata?.meta_whatsapp_template_status_name && template.whatsapp_template_metadata?.meta_whatsapp_template_status_name.toLowerCase() === "approved") || template.whatsapp_template_flag_interactive_message) && !template.flag_allow_tracking)
        if(isCarouselTemplateActionType(stepAction?.action_type?.action_type_name)){
            filteredTemplateList = filteredTemplateList?.filter((template) => isCarouselTemplate(template))
        } else if(isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name)){
            filteredTemplateList = filteredTemplateList?.filter((template) => isInteractiveTypeMessageOrderDetails(template?.interactive_type?.interactive_type_id, interactiveTypeList));
        } 
        else { 
            filteredTemplateList = filteredTemplateList?.filter((template) => (!isCarouselTemplate(template) && !isInteractiveTypeMessageOrderDetails(template?.interactive_type?.interactive_type_id, interactiveTypeList)))
        }
        return filteredTemplateList
    }

    const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }

    const renderFieldOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={autoCompleteStyles.newTagNameUlElement}>
                    <Divider className={autoCompleteStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container className={globalStyles.wordBreakBreakAll}>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={waCampaignStyle.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}
                        >
                            <EditIcon sx={{ height: "14px", width: "14px", fontSize: "14px" }} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}
                        >
                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor="#7A7A7A" />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    } 

    const getAllButtonVariableData = (button: whatsappTemplateButton[]) => {
        return button.flatMap(btn =>
            btn.whatsapp_template_button_data.flatMap(data =>
                data.whatsapp_template_button_sub_type_field_data.flatMap(field =>
                    field.whatsapp_template_button_field_data_variable || []
                )
            )
        )
    } 

    const handleValidWebsite = (website_value: string, index: number) => {
        if (website_value.trim().length > 0) {
            let temp = validator.isURL(website_value)
            if (temp) {
                if (inValidIdRef.current.includes(index)) {
                    setInValidVariableId(inValidIdRef.current.filter((ele: number) => ele != index))
                    inValidIdRef.current = inValidIdRef.current.filter((ele: number) => ele != index);
                } else {
                }
            } else {
                if (inValidIdRef.current.includes(index)) {
                } else {
                    setInValidVariableId((prev) => [...prev, index])
                    inValidIdRef.current = [...inValidIdRef.current, index];
                }
            }
        } else if (website_value.trim().length == 0) {
            if (inValidIdRef.current.includes(index)) {
                setInValidVariableId(inValidIdRef.current.filter((ele: number) => ele != index))
                inValidIdRef.current = inValidIdRef.current.filter((ele: number) => ele != index);
            } else {
            }
        }
    }

    const onBlurOfFallBackOfBtnVar = useCallback(
        debounce((value: string, index: number) => {
            handleValidWebsite(value, index);
        }, 800), []
    ); 

    const uploadFileHandler = async (e: any, whatsapp_template_dynamic_variable_id: number) => {
        for (var i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];

            file.isUploading = true;
            setFiles([file]);

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");

            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }
            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await agent.uploadFile.post(formData, config).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setFiles((old: any) => {
                        let temp = [...old]
                        let fileType = file.name.split('.').pop()
                        let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                        temp.map((rr: any) => {
                            if (rr.google_storage_id == file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        })
                        return temp
                    })
                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                        { flag_fallback: true, fallback_value: res.data.data.file_path, whatsapp_template_dynamic_variable_id: whatsapp_template_dynamic_variable_id },
                        {
                            updateType: "editExistingStepAction"
                        }
                    ) 
                    setInValidVariableId((prev) => prev?.filter((id) => id != whatsapp_template_dynamic_variable_id));
                    setIsFileUploaded(false);
                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                console.error(err)
            });
            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }
    }

    const removeFileHandler = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        await agent.removeUploadedFile.delete(files[0].file_data.google_storage_id).then(async (res) => {
            if (res.data.status) {
                setFiles([]);
                showSuccess("File Deleted Successfully")
            } else {
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        setFiles([]);
    } 

    const flagShowFlowVariables = (messageTemplateDetail: any) => {
        return messageTemplateDetail && messageTemplateDetail?.whatsapp_template_data && messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button && 
        messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button?.find((btn: any) => {
            return btn.whatsapp_template_button_data?.find((btnData: any) => {
                return btnData?.whatsapp_template_button_type_name?.toLowerCase() == "flow" && btnData?.whatsapp_template_button_sub_type_name?.toLowerCase() == "open form";
            });
        })
    } 

    const flagShowInputFlowVariabless = () => {
        return whatsappFlowData?.some(waFlow =>
            waFlow?.whatsapp_flow_version_data?.some(
                version =>
                    version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() === "published" &&
                    version?.whatsapp_flow_variables?.some((variable) => variable?.input_variable_flag)
                )
            ) ?? false;
    }

    return (
        <Grid item className={`${globalStyles.fullwidth} ${globalStyles.fullHeight}`}>
            <Grid container gap={"15px"} flexWrap={"nowrap"} className={globalStyles.fullHeight}>
                <Grid item xs={12} md={7} lg={8} className={`${globalStyles.fullHeight} ${globalStyles.overflowAuto}`} sx={{ padding: "5px" }}>
                    <Grid container gap={"15px"}>
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container direction={"column"} gap={"10px"}>
                                <Grid item className={styles.createWorkflowLabelStyle}>WhatsApp Business Account <Required /> {!selectedWBA && `(To select a template you need to configure a WhatsApp Business Account first)`}</Grid>
                                <Grid item>
                                    <Autocomplete
                                        className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                        options={integrationListNewStructure ? integrationListNewStructure?.filter((list: any) => list.channel_name.toLowerCase() === "whatsapp") : []}
                                        getOptionLabel={(option: any) => option.waba_name ? option.waba_name : "WhatsApp Account"}
                                        value={selectedWBA}
                                        onChange={(_, value: any) => onChangeOfWBA(value)}
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment && currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.length > 0 ? true : false}
                                        renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Business Account" />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container direction={"column"} gap={"10px"}>
                                <Grid item className={styles.createWorkflowLabelStyle}>WhatsApp Business Phone Number </Grid>
                                <Grid item>
                                    <Autocomplete
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || !selectedWBA}
                                        className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                        options={getWhatsAppNumberOptions()}
                                        getOptionLabel={(option) => option.display_phone_number}
                                        value={getWhatsAppNumberValue()}
                                        onChange={(_, value: any) => { onChangeOfPhoneNumber(value); }}
                                        renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Number" />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedWBA &&
                            <Grid item className={globalStyles.fullwidth}>
                                <Grid container direction={"column"} gap="10px">
                                    <Grid item className={styles.createWorkflowLabelStyle}>
                                        <Grid container alignItems={"center"} gap="7px">
                                            <Grid item>   Select {isCarouselTemplateActionType(stepAction?.action_type?.action_type_name) && 'Carousel '} Message Template <Required /></Grid>
                                            <Grid item>
                                                {messageTemplateDetail?.whatsapp_template_id &&
                                                    <Tooltip title="View Template in detail">
                                                        {/* <VisibilityIcon className={globalStyles.clickable} onClick={() => { window.open(`${window.location.origin}/channels/viewintegration/whatsapp/legacy/templateinfo?id=${selectedWBA.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail.whatsapp_template_id}`, "_blank") }} /> */}
                                                        <VisibilityIcon 
                                                            className={globalStyles.clickable} 
                                                            // onClick={() => { 
                                                            //     isCarouselTemplate(messageTemplateDetail) 
                                                            //     ? window.open(`${window.location.origin}/channels/viewintegration/whatsapp/legacy/templateinfo?id=${selectedWBA.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail.whatsapp_template_id}`, "_blank") 
                                                            //     : window.open(`${window.location.origin}/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${selectedWBA.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail.whatsapp_template_id}`, "_blank") 
                                                            // }} 
                                                            onClick={() => { 
                                                                window.open(`${window.location.origin}/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${selectedWBA.meta_integration_whatsapp_id}&template_id=${messageTemplateDetail.whatsapp_template_id}`, "_blank") 
                                                            }} 
                                                        />
                                                    </Tooltip>}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || !selectedWBA}
                                            className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                            options={messageTemplateList ? getFilteredTemplateList(messageTemplateList) : []}
                                            getOptionLabel={(option) => option.whatsapp_template_data?.[0].whatsapp_template_display_name ?? option.whatsapp_template_data?.[0]?.whatsapp_template_name}
                                            value={messageTemplateDetail}
                                            onChange={(_, value: getTemplateDetails | null) => {
                                                setInvalidHeaderId([])
                                                setInvalidButtonId([]) 
                                                setInValidVariableId([])
                                                if (value) {
                                                    setWaTemplateFetchedOnChange(true);
                                                    getTemplateDetailsFromMessageTemplate(value ? Number(value?.meta_integration_whatsapp_id) : undefined, value?.whatsapp_template_id)
                                                }
                                                else {
                                                    setMessageTemplateDetail(null);
                                                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                                        {
                                                            flag_update_wa_template: true, 
                                                            flag_update_wa_flow_variable: true,
                                                            wa_template: {
                                                                whatsapp_template_id: null,
                                                                whatsapp_template_name: null,
                                                                whatsapp_template_display_name: null
                                                            },
                                                            wa_variables: [], 
                                                            wa_flow_variables: null,
                                                        },
                                                        {
                                                            updateType: "editExistingStepAction"
                                                        }
                                                    );
                                                }
                                            }}
                                            renderOption={renderOptions}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Message Template" />}
                                            // getOptionDisabled={(option) => {
                                            //     if(nodes?.find((node: any) => node?.id == currentActiveNodeConfig.nodeId)?.data?.find((data: any) => data?.action_type?.action_type_name == "save_variable") && option?.whatsapp_template_flag_flow){
                                            //         return true;
                                            //     } 
                                            //     return false;
                                            // }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>}

                        {messageTemplateDetail &&
                            <Grid item className={globalStyles.fullwidth}>
                                <Grid container direction={"column"} gap={2}>
                                    <Grid item mt={1}>
                                        <Divider />
                                    </Grid>
                                    {mobileScreen &&
                                        <Grid item onClick={() => setShowTemplatePreview(true)}>
                                            <Grid container sx={{ gap: "5px", cursor: "pointer", justifyContent: "end" }}>
                                                <img
                                                    src={previewIcon}
                                                    className={globalStyles.previewIconStyle}
                                                    alt=""
                                                />
                                                <Typography
                                                    component={'span'}
                                                    className={globalStyles.previewIconFont}
                                                >
                                                    Preview
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    }
                                    {mobileScreen &&
                                        <Grid item xs={12} md={5} lg={4} key={showTemplatePreview ? "visible" : "hidden"} mt={1} className={`${styles.previewSectionStyle} ${showTemplatePreview ? styles.previewSectionVisible : styles.previewSectionHidden}`}>
                                            <Grid container gap={2} justifyContent={"center"} alignItems={"center"}>
                                                <Grid item xs={12} textAlign={"center"}>
                                                    <Grid container sx={{ gap: "5px", cursor: "pointer", justifyContent: "center" }}>
                                                        <Typography
                                                            component={'span'}
                                                            className={globalStyles.previewIconFont}
                                                        >
                                                            Template Preview
                                                        </Typography>
                                                        <img
                                                            src={previewIcon}
                                                            className={globalStyles.previewIconStyle}
                                                            alt="Preview"
                                                            style={{ transform: "rotate(180deg)", position: "absolute", right: "25px" }}
                                                            onClick={() => setShowTemplatePreview(false)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {
                                                        isCarouselTemplate(messageTemplateDetail) ?
                                                        <WorkflowCarouselTemplatePreview actionData={actionData} messageTemplateDetail={messageTemplateDetail} />
                                                        : 
                                                        <WorkflowTemplatePreview flagWorkFlow={true} stepAction={stepAction} actionData={actionData} messageTemplateDetail={messageTemplateDetail} />
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                    {(flagShowBodyVariable() || flagShowHeaderVariables() || flagShowButtonVariable() || isCarouselTemplate(messageTemplateDetail)) &&
                                        <Grid item sx={{ backgroundColor: isCarouselTemplate(messageTemplateDetail) ? "#FAFAFA" : "#F4F4F4", padding: "0px 10px", width: "100%" }}> 
                                            {isCarouselTemplate(messageTemplateDetail) ?
                                                <>
                                                    {flagShowCarouselGlobalHeaderVariable(messageTemplateDetail) && 
                                                        <CarouselGlobalHeaderVariables 
                                                            actionData={actionData} 
                                                            stepAction={stepAction} 
                                                            messageTemplateDetail={messageTemplateDetail}
                                                            renderFieldOptions={renderFieldOptions} 
                                                            getFieldTypeValue={getFieldTypeValue} 
                                                            getFieldValue={getFieldValue} 
                                                            getFallbackValue={getFallbackValue}
                                                        /> 
                                                    }
                                                    <CarouselCardVariables 
                                                        actionData={actionData} 
                                                        stepAction={stepAction} 
                                                        messageTemplateDetail={messageTemplateDetail}
                                                        renderFieldOptions={renderFieldOptions} 
                                                        getFieldTypeValue={getFieldTypeValue}  
                                                        getFieldValue={getFieldValue} 
                                                        getFallbackValue={getFallbackValue} 
                                                        getAllButtonVariableData={getAllButtonVariableData} 
                                                        onBlurOfFallBackOfBtnVar={onBlurOfFallBackOfBtnVar} 
                                                        uploadFileHandler={uploadFileHandler}
                                                        removeFileHandler={removeFileHandler} 
                                                        files={files}
                                                        isFileUploaded={isFileUploaded}
                                                    />
                                                </>
                                                :
                                                <>
                                                    {flagShowHeaderVariables() &&
                                                        <DynamicHeaderVariables 
                                                            actionData={actionData} 
                                                            stepAction={stepAction}
                                                            messageTemplateDetail={messageTemplateDetail}  
                                                            onBlurOfFallBackOfBtnVar={onBlurOfFallBackOfBtnVar} 
                                                            renderFieldOptions={renderFieldOptions} 
                                                            getFieldTypeValue={getFieldTypeValue}
                                                            getFieldValue={getFieldValue} 
                                                            getFallbackValue={getFallbackValue} 
                                                            uploadFileHandler={uploadFileHandler}
                                                            removeFileHandler={removeFileHandler} 
                                                            files={files}
                                                            isFileUploaded={isFileUploaded}
                                                        />
                                                    }
                                                    {flagShowBodyVariable() &&
                                                        <DynamicBodyVariables 
                                                            actionData={actionData} 
                                                            stepAction={stepAction} 
                                                            messageTemplateDetail={messageTemplateDetail} 
                                                            renderFieldOptions={renderFieldOptions} 
                                                            getFieldTypeValue={getFieldTypeValue}  
                                                            getFieldValue={getFieldValue} 
                                                            getFallbackValue={getFallbackValue} 
                                                        />
                                                    }
                                                    {flagShowButtonVariable() &&
                                                        <DynamicButtonVariables 
                                                            actionData={actionData} 
                                                            stepAction={stepAction} 
                                                            messageTemplateDetail={messageTemplateDetail} 
                                                            onBlurOfFallBackOfBtnVar={onBlurOfFallBackOfBtnVar} 
                                                            renderFieldOptions={renderFieldOptions} 
                                                            getFieldTypeValue={getFieldTypeValue}  
                                                            getFieldValue={getFieldValue} 
                                                            getFallbackValue={getFallbackValue} 
                                                        />
                                                    } 
                                                </>
                                            }
                                        </Grid>
                                    } 
                                     {flagShowSendOrderDetailProductVariable() &&  // Send Order Details Product Variables
                                        <Grid item sx={{backgroundColor: "#F4F4F4", padding: "0px 10px", width: "100%"}}>
                                            <SendOrderDetailsProductVariables
                                                actionData={actionData} 
                                                stepAction={stepAction} 
                                                messageTemplateDetail={messageTemplateDetail} 
                                                renderFieldOptions={renderFieldOptions} 
                                                // getFieldTypeValue={getFieldTypeValue}  
                                                // getFieldValue={getFieldValue} 
                                                // getFallbackValue={getFallbackValue} 
                                                eComProductDataList={eComProductDataList as EcomProduct[]}
                                            />
                                        </Grid>
                                    }
                                    {flagShowInputFlowVariabless() && 
                                        <Grid item sx={{backgroundColor: "#F4F4F4", padding: "0px 10px", width: "100%"}}>
                                            <FlowVariables
                                                whatsappFlowData={whatsappFlowData} 
                                                stepAction={stepAction}  
                                                getFieldTypeValueForFlowVariable={getFieldTypeValueForFlowVariable} 
                                                renderFieldOptions={renderFieldOptions} 
                                                getFieldValueForFlowVariable={getFieldValueForFlowVariable} 
                                                getFallbackValueForFlowVariable={getFallbackValueForFlowVariable}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>

                {!mobileScreen &&
                    <Grid item xs={12} md={5} lg={4} mt={1} className={`${styles.previewSectionStyle}`}>
                        <Grid container gap={2} justifyContent={"center"} alignItems={"center"}>
                            <Grid item xs={12} textAlign={"center"}>
                                <Grid container sx={{ gap: "5px", cursor: "pointer", justifyContent: "center" }}>
                                    <Typography
                                        component={'span'}
                                        className={globalStyles.previewIconFont}
                                    >
                                        Template Preview
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    isCarouselTemplate(messageTemplateDetail) ?
                                    <WorkflowCarouselTemplatePreview actionData={actionData} messageTemplateDetail={messageTemplateDetail} />
                                    : 
                                    <WorkflowTemplatePreview flagWorkFlow={true} stepAction={stepAction} actionData={actionData} messageTemplateDetail={messageTemplateDetail} />
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default WhatsappTemplateIntegration